export default "__VITE_ASSET__8b9cacf3__"